<template>
  <div class="w-full">
    <div class="h-60 flex a-center j-center">
      <span>选择图标</span>
    </div>
    <div class="w-full" style="min-height: 100px">
      <Row>
        <Col span="12">
          <div class="flex a-center j-center h-40">
            选前图标
          </div>
          <div class="flex a-center j-center">
            <div @click="onBeforeChooseClick" style="width: 40px;height: 40px">
              <img src="../../../../assets/common/ic_default_img.png"
                   style="width: 40px;height: 40px;cursor: pointer" v-if="!editPicData.iconUrl">
              <img :src="editPicData.iconUrl" style="width: 40px;height: 40px;cursor: pointer"
                   v-if="editPicData.iconUrl">
            </div>
          </div>
        </Col>
        <Col span="12">
          <div class="flex a-center j-center h-40">
            选中图标
          </div>
          <div class="flex a-center j-center">
            <div @click="onAfterChooseClick" style="width: 40px;height: 40px">
              <img src="../../../../assets/common/ic_default_img.png"
                   style="width: 40px;height: 40px;cursor: pointer" v-if="!editPicData.iconSelUrl">
              <img :src="editPicData.iconSelUrl" style="width: 40px;height: 40px;cursor: pointer"
                   v-if="editPicData.iconSelUrl">
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <div class="h-60 flex a-center j-center">
      <Button @click="onCancelClick" style="width: 100px">取消</Button>
      <Button @click="onOKClick" class="m-l-30" style="width: 100px">确定</Button>
    </div>
    <source-choose-widget :chooseType="4" @ok="onSourceChoose" ref="picChoiceWidget">

    </source-choose-widget>
    <!--<pic-choice-widget :on-ok="picChoiceOk" ref="picChoiceWidget"/>-->
  </div>
</template>

<script>
import PicChoiceWidget from '../../../../components/common/chiose/PicChoiceWidget'
import SourceChooseWidget from '../../../../components/source/SourceChooseWidget'
import {mapActions} from 'vuex'

export default {
  name: 'PicChooseWidget',
  components: {SourceChooseWidget, PicChoiceWidget},
  props: {
    editPicData: {
      type: Object,
      default: () => {
        return {
          id: 0,
          iconSelUrl: '',
          iconUrl: '',
          iconId: 0,
          selectedIconId: 0
        }
      }
    }
  },
  data () {
    return {
      chooseType: 0
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    onBeforeChooseClick () {
      this.chooseType = 1
      this.$refs.picChoiceWidget.show()
    },
    onAfterChooseClick () {
      this.chooseType = 2
      this.$refs.picChoiceWidget.show()
    },
    picChoiceOk (data) {
      if (data && data.length) {
        if (this.chooseType === 1) {
          this.editPicData.iconUrl = data[0].url
        } else if (this.chooseType === 2) {
          this.editPicData.iconSelUrl = data[0].url
        }
      }
    },
    onCancelClick () {
      this.$emit('cancel')
    },
    onOKClick () {
      let editPicData = this.editPicData
      let params = {
        id: editPicData.id,
        selectedIcon: editPicData.iconSelUrl || '',
        icon: editPicData.iconUrl || ''
      }
      if (editPicData.iconId) {
        params.iconId = editPicData.iconId
      }

      if (editPicData.selectedIconId) {
        params.selectedIconId = editPicData.selectedIconId
      }
      this.updateNavItem(params).then(res => {
        if (res.code === 0) {
          this.$emit('ok')
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }
      })

    },
    onSourceChoose (data, next) {
      if (data && data.length) {
        if (this.chooseType === 1) {
          this.editPicData.iconUrl = data[0].url
          this.editPicData.iconId = data[0].imgId
        } else if (this.chooseType === 2) {
          this.editPicData.iconSelUrl = data[0].url
          this.editPicData.selectedIconId = data[0].imgId
        }
      }
      next()
    },
    ...mapActions([
      'updateNavItem',
    ])
  }
}
</script>

<style lang="scss" scoped>

</style>
